// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__vtvdN","footer":"Form_footer__3AiFM"};